const init = () => {
    $(".ns-text-and-image__carousel-container").each(function () {
        const $container = $(this);

        $container.owlCarousel({
            items: 1,
            center: true,
            loop: true,
            nav: false,
            dots: true,
            smartSpeed: 800,
            margin: 16,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true
        });
    });
};

window.addEventListener("DOMContentLoaded", init, false);
